import React, { useState, useRef, useEffect } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import BarcodeScanner from "../barcode/BarcodeScanner";
import { FaQrcode } from "react-icons/fa";
import ReactModal from "react-modal";
import { LookUpFormField } from "./LookUpFormField";
import useTaskDetailsFormControlStore from '../stores/TaskDetailsFormControlStore';
import useTaskStore from '../stores/useTaskStore';
import { formatSealWatermeterId } from "../app/WmUtils";
import { toast } from "react-toastify";

const WmeterForm = (props) => {
  const [propState, setPropState] = useState(props);
  const [barCodeRes, setBarCodeRes] = useState(null);
  const [barcodeScannerOn, setBarcodeScannerOn] = useState(false);
  const [lookupFieldReload, setLookupFieldReload] = useState(null);
  const [localPhysicalPlace, setLocalPhysicalPlace] = useState(propState.defaultPhysicalPlace || "");
  const cold_hotRef = useRef();
  const placeRef = useRef();
  const sizeRef = useRef();
  const lengthRef = useRef();
  const transmitterRef = useRef();  
  const meterValidFromRef = useRef();  
  const modelRef = useRef();
  const okRef = useRef();
  const meterRef = useRef();
  const idRef = useRef();
  const p1idRef = useRef();
  const p1okRef = useRef();
  const p2idRef = useRef();
  const p2okRef = useRef();
  const noteRef = useRef();

  const {isButtonDisabled} = useTaskDetailsFormControlStore((state) => ({
    isButtonDisabled: state.isButtonDisabled
}));
  const { selectedTask } = useTaskStore();

  const propStateListWmItem = props.wmWorkList[`${props.actTask}`].wmlist[props.item];
  propStateListWmItem.current=props.wmWorkList[`${props.actTask}`].wmlist[props.item];
  const isNewWaterMeter = !!propStateListWmItem.current?.is_new;

  useEffect(() => {
    setLocalPhysicalPlace(propState.defaultPhysicalPlace);
  },[propState.defaultPhysicalPlace]);

  useEffect(() => {
    const primaryWatermeterLocation  = !!propStateListWmItem.current.watermeter_physical_place
    ? propStateListWmItem.current.watermeter_physical_place
    : selectedTask.work_watermeter_physical_place;
    setLocalPhysicalPlace(primaryWatermeterLocation );
  },[]);

  useEffect(() => {
    setPropState(props);
  }, [props]);

  useEffect(() => {
      propStateListWmItem.current = propState.wmWorkList[`${propState.actTask}`].wmlist[propState.item];
  }, [propState]);

  const updateWaterMeterData = (identifier) => {
    let wmItem=propState.wmList?.current.find((element) => element.watermeter_id == identifier);
    if(!!wmItem){
      cold_hotRef.current.value=wmItem.is_cold ?? undefined;
      modelRef.current.value=wmItem.meter_model;
      lengthRef.current.value=wmItem.meter_length_in_mm;
      meterValidFromRef.current.value=wmItem.meter_valid_from;
      transmitterRef.current.value=wmItem.meter_is_transmitter_supported ?? undefined;
      toast.success("Vízmérő adatok frissítve a gyáriszám alapján.");
    } else {
      //default values not here defined 
      return;
    }
  };

  /*eslint-disable eqeqeq*/
  const onInputChange = async (event) => {
    event?.preventDefault();
    let tempInvItem = Object.assign({}, propState.wmWorkList);
    const actInvItemListItem =
      tempInvItem[`${propState.actTask}`].wmlist[propState.item];
    actInvItemListItem.is_cold = cold_hotRef.current.value;
    actInvItemListItem.watermeter_physical_place = placeRef.current.value;
    actInvItemListItem.size = sizeRef.current.value;
    actInvItemListItem.meter_ok = okRef.current.value;
    actInvItemListItem.act_meter = meterRef.current.value;
    actInvItemListItem.meter_length_in_mm = lengthRef.current.value;
    actInvItemListItem.meter_is_transmitter_supported = transmitterRef.current.value;
    actInvItemListItem.meter_valid_from = meterValidFromRef.current.value;
    actInvItemListItem.meter_model = modelRef.current.value;
    if (!!idRef?.current?.value)
      actInvItemListItem.meter_identifier = idRef.current.value;
    if (!!p1idRef?.current?.value)
      actInvItemListItem.plomba1_identifier = p1idRef.current.value;
    actInvItemListItem.plomba1_ok = p1okRef.current.value;
    if (!!p2idRef?.current?.value) {
      actInvItemListItem.plomba2_identifier =
        p2idRef.current.value == "---" ? null : p2idRef.current.value;
    }
    actInvItemListItem.plomba2_ok = p2okRef.current.value;
    actInvItemListItem.note = noteRef.current.value;

    propState.SetWmWorkList(tempInvItem);
  };
  useEffect(() => {
    if (!!barCodeRes) {
      const barcode = formatSealWatermeterId(barCodeRes);
      let tempInvItem = Object.assign({}, propState.wmWorkList);

      switch (barcodeScannerOn) {
        case idRef:
          tempInvItem[`${propState.actTask}`].wmlist[
            propState.item
          ].meter_identifier = barcode;
          if (idRef?.current) idRef.current.value = barcode;
          break;
        case p1idRef:
          tempInvItem[`${propState.actTask}`].wmlist[
            propState.item
          ].plomba1_identifier = barcode;
          if (p1idRef?.current) p1idRef.current.value = barcode;
          break;
        case p2idRef:
          tempInvItem[`${propState.actTask}`].wmlist[
            propState.item
          ].plomba2_identifier = barcode;
          if (p2idRef?.current) p2idRef.current.value = barcode;
          break;

        default:
          break;
      }
      propState.SetWmWorkList(tempInvItem);
      setBarcodeScannerOn(null);
      setBarCodeRes(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [barCodeRes]);

  return (
    <>
      <ReactModal
        key={propState.keyProp + "barcmod"}
        isOpen={!!barcodeScannerOn}
        appElement={document.getElementById("root")}
        style={{
          width: "100%",
          height: "100%",
          margin: "0",
          padding: "0",
          dialog: {
            width: "100%",
            height: "100%",
            margin: "0",
            padding: "0",
          },
          content: {
            width: "100%",
            height: "auto",
            minHeight: "100%",
            inset: "0",
            borderRadius: "0",
            margin: "0",
            padding: "0",
          },
        }}
        contentLabel="Barcode Modal"
      >
        <BarcodeScanner
          setBarCodeRes={(bcRs) => {
            setBarCodeRes(bcRs); /*  wmBcode.exit();  */
          }}
          key={propState.keyProp + "barcrdr"}
        />
      </ReactModal>
      <Form key={propState.keyProp + "wmform"}>
        <Form.Group controlId="phys">
          <Form.Label>
            <small style={{ color: "indigo", textAlign: "left" }}>
              Készülékhely/felhasználási hely:
            </small>
          </Form.Label>
          <Form.Control
            disabled={isButtonDisabled}
            placeholder="Vízmérő helye"
            defaultValue={localPhysicalPlace}
            onBlur={(e) => { onInputChange(e); propState.setDefaultPhysicalPlaces(e.target.value);}}
            name="note"
            ref={placeRef}
          />
        </Form.Group>
        <Form.Group controlId="wm_id">
          <Form.Label key={propState.keyProp + "focus"}
              ref={(focref) => {
                if (!!focref)
                  propState.focusRefList.current[propState.keyProp + "focus"] =
                    focref;
              }}>
            <small style={{ color: "indigo", textAlign: "left" }}>
              Gyáriszám:
            </small>
          </Form.Label>
          <Form.Row className="align-items-center ">
            <Col className="px-0">
              {isNewWaterMeter ? (
                <LookUpFormField
                  placeholder="Gyáriszám"
                  onBlur={(e) => { updateWaterMeterData(idRef.current.value); onInputChange(e); }}
                  defaultValue={propStateListWmItem.current.meter_identifier}
                  name="wmID"
                  parentRef={idRef}
                  optDataList={propState.wmList}
                  wmItem={propState.item}
                  wmListOfTask={propState.wmWorkList[`${props.actTask}`].wmlist}
                  taskId={props.actTask}
                  lookupFieldReload={lookupFieldReload}
                  setLookupFieldReload={setLookupFieldReload}
                  disabled={!!propStateListWmItem.current.id || isButtonDisabled}
                />
              ) : (
                <Form.Control
                  disabled={!!propStateListWmItem.current.id || isButtonDisabled}
                  type="text"
                  placeholder="Gyáriszám"
                  onBlur={onInputChange}
                  defaultValue={propStateListWmItem.current.meter_identifier}
                  name="wmID"
                  ref={idRef}
                />
              )}
            </Col>
            <Col xs="auto">
              <Button
                disabled={!!propStateListWmItem.current.id || isButtonDisabled}
                className="px-1 mx-0 py-0 "
                variant="outline-dark"
                onClick={() => {
                  /* wmBcode.enter();  */ setBarcodeScannerOn(idRef);
                }}
              >
                <h5>
                  <FaQrcode />
                </h5>
              </Button>
            </Col>
          </Form.Row>
        </Form.Group>

        <Form.Group controlId="cold_hot" classname="container">
          <div class="row">
            <div class="col">          
              <Form.Label>
                <small style={{ color: "indigo", textAlign: "left" }}>
                  Hideg/meleg:
                </small>
              </Form.Label>
              <Form.Control
                disabled={isButtonDisabled}
                onBlur={onInputChange}
                as="select"
                custom
                ref={cold_hotRef}
                defaultValue={propStateListWmItem.current.is_cold}
              >
                <option value={null}>Válassz...</option>
                <option value={false}>Meleg</option>
                <option value={true}>Hideg</option>
              </Form.Control>{" "}
            </div>

            <div class="col">          
              <Form.Label>
                <small style={{ color: "indigo", textAlign: "left" }}>
                  Jeladós:
                </small>
              </Form.Label>
              <Form.Control
                disabled={isButtonDisabled}
                onBlur={onInputChange}
                as="select"
                custom
                ref={transmitterRef}
                defaultValue={propStateListWmItem.current.meter_is_transmitter_supported}
              >
                <option value={null}>Válassz...</option>
                <option value={false}>Nem</option>
                <option value={true}>Igen</option>
              </Form.Control>{" "}
            </div>
          </div>
        </Form.Group>
        <Form.Group controlId="size" classname="container">
          <div class="row">
            <div class="col">
              <Form.Label>
                <small style={{ color: "indigo", textAlign: "left" }}>
                  Vízmérő átmérő:
                </small>
              </Form.Label>

              <Form.Control
                disabled={isButtonDisabled}
                onBlur={onInputChange}
                as="select"
                custom
                ref={sizeRef}
                defaultValue={propStateListWmItem.current.size}
              >
                <option value={null}>Válassz...</option>
                <option value={13}>13</option>
                <option value={15}>15</option>
                <option value={20}>20</option>
                <option value={25}>25</option>
                <option value={32}>32</option>
              </Form.Control>{" "}
            </div>
            <div class="col">
              <Form.Label>
                <small style={{ color: "indigo", textAlign: "left" }}>
                  Beépítési hossz:
                </small>
              </Form.Label>
              <Form.Control
                disabled={isButtonDisabled}
                onBlur={onInputChange}
                as="select"
                custom
                ref={lengthRef}
                defaultValue={propStateListWmItem.current.meter_length_in_mm}
              >
                <option value={null}>Válassz...</option>
                <option value={80}>80</option>
                <option value={105}>105</option>
                <option value={110}>110</option>
                <option value={130}>130</option>
                <option value={165}>165</option>
                <option value={170}>170</option>
                <option value={190}>190</option>
                <option value={260}>260</option>
                <option value={300}>300</option>
              </Form.Control>{" "}
            </div>
          </div>    
        </Form.Group>
        <Form.Group controlId="meterok" classname="container">
          <div class="row">
            <div class="col">
              <Form.Label>
                <small style={{ color: "indigo", textAlign: "left" }}>
                  {" "}
                  Vízmérő állapota:
                </small>
              </Form.Label>
              <Form.Control
                disabled={isButtonDisabled}
                onBlur={onInputChange}
                as="select"
                className="my-1 mr-sm-2"
                custom
                ref={okRef}
                defaultValue={propStateListWmItem.current.meter_ok}
              >
                <option value={null}>Hiányzik</option>
                <option value={true}>Ép</option>
                <option value={false}>Sérült</option>
              </Form.Control>{" "}
            </div>
            <div class="col">
              <Form.Label>
                <small style={{ color: "indigo", textAlign: "left" }}>
                  {" "}
                  Modell:
                </small>
              </Form.Label>
              <Form.Control
                disabled={isButtonDisabled}
                type="text"
                placeholder="MOM"
                onBlur={onInputChange}
                defaultValue={propStateListWmItem.current.meter_model}
                name="model"
                ref={modelRef}
              />{" "}
            </div>    
          </div>    
        </Form.Group>
        <Form.Group controlId="meter" classname="container">
          <div class="row">
            <div class="col">
              <Form.Label>
                <small style={{ color: "indigo", textAlign: "left" }}>
                  Mérőállás:
                </small>
              </Form.Label>
              <Form.Control
                disabled={isButtonDisabled}
                type="number"
                placeholder="Mérő állása"
                onBlur={onInputChange}
                defaultValue={propStateListWmItem.current.act_meter}
                name="meter"
                ref={meterRef}
              />{" "}
            </div>    
            <div class="col"> 
              <Form.Label>
                <small style={{ color: "indigo", textAlign: "left" }}>
                  {" "}
                  Hitelesítés:
                </small>
              </Form.Label>
              <Form.Control
                disabled={isButtonDisabled}
                as="select"
                placeholder="MOM"
                onBlur={onInputChange}
                name="model"
                custom
                ref={meterValidFromRef}
                defaultValue={propStateListWmItem.current.meter_valid_from}
              >
                <option value={null}>Válassz...</option>
                <option value={new Date().getFullYear()-12}>{new Date().getFullYear()-12}</option>
                <option value={new Date().getFullYear()-11}>{new Date().getFullYear()-11}</option>
                <option value={new Date().getFullYear()-10}>{new Date().getFullYear()-10}</option>
                <option value={new Date().getFullYear()-9}>{new Date().getFullYear()-9}</option>
                <option value={new Date().getFullYear()-8}>{new Date().getFullYear()-8}</option>
                <option value={new Date().getFullYear()-7}>{new Date().getFullYear()-7}</option>
                <option value={new Date().getFullYear()-6}>{new Date().getFullYear()-6}</option>
                <option value={new Date().getFullYear()-5}>{new Date().getFullYear()-5}</option>
                <option value={new Date().getFullYear()-4}>{new Date().getFullYear()-4}</option>
                <option value={new Date().getFullYear()-3}>{new Date().getFullYear()-3}</option>
                <option value={new Date().getFullYear()-2}>{new Date().getFullYear()-2}</option>
                <option value={new Date().getFullYear()-1}>{new Date().getFullYear()-1}</option>
                <option value={new Date().getFullYear()}>{new Date().getFullYear()}</option>
                <option value={new Date().getFullYear()+1}>{new Date().getFullYear()+1}</option> 
              </Form.Control>{" "}
            </div>
          </div>    
        </Form.Group>

        <Form.Group controlId="p1_id">
          <Form.Label>
            <small style={{ color: "indigo", textAlign: "left" }}>
              Biztonsági záróelem-1 száma:
            </small>
          </Form.Label>
          <Form.Row className="align-items-center">
            <Col className="px-0">
              {isNewWaterMeter ? (
                <LookUpFormField
                  placeholder="Biztonsági záróelem-1 száma"
                  onBlur={onInputChange}
                  defaultValue={propStateListWmItem.current.plomba1_identifier}
                  name="seal1ID"
                  parentRef={p1idRef}
                  optDataList={propState.sealList}
                  wmItem={propState.item}
                  wmListOfTask={propState.wmWorkList[`${props.actTask}`].wmlist}
                  taskId={props.actTask}
                  lookupFieldReload={lookupFieldReload}
                  setLookupFieldReload={setLookupFieldReload}
                  disabled={!!propStateListWmItem.current.id || isButtonDisabled}
                />
              ) : (
                <Form.Control
                  disabled={!!propStateListWmItem.current.id || isButtonDisabled}
                  type="text"
                  placeholder="Biztonsági záróelem-1 száma"
                  onBlur={onInputChange}
                  defaultValue={propStateListWmItem.current.plomba1_identifier}
                  name="seal1ID"
                  ref={p1idRef}
                />
              )}
            </Col>
            <Col xs="auto">
              <Button
                disabled={!!propStateListWmItem.current.id || isButtonDisabled}
                className="px-1 mx-0 py-0 "
                variant="outline-dark"
                onClick={() => {
                  /*  wmBcode.enter();  */ setBarcodeScannerOn(p1idRef);
                }}
              >
                <h5>
                  <FaQrcode />
                </h5>
              </Button>
            </Col>
          </Form.Row>
        </Form.Group>
        <Form.Group controlId="p1ok">
          <Form.Label className="my-1 mr-2">
            <small style={{ color: "indigo", textAlign: "left" }}>
              Záróelem-1 állapota:
            </small>
          </Form.Label>
          <Form.Control
            disabled={isButtonDisabled}
            onBlur={onInputChange}
            as="select"
            className="my-1 mr-sm-2"
            custom
            ref={p1okRef}
            defaultValue={propStateListWmItem.current.plomba1_ok}
          >
            <option value={null}>Hiányzik</option>
            <option value={true}>Ép</option>
            <option value={false}>Sérült</option>
          </Form.Control>{" "}
        </Form.Group>
        <Form.Group controlId="p2_id">
          <Form.Label>
            <small style={{ color: "indigo", textAlign: "left" }}>
              Biztonsági záróelem-2 száma:
            </small>
          </Form.Label>
          <Form.Row className="align-items-center">
            <Col className="px-0">
              {isNewWaterMeter ? (
                <LookUpFormField
                  placeholder="Biztonsági záróelem-2 száma"
                  onBlur={onInputChange}
                  defaultValue={propStateListWmItem.current.plomba2_identifier}
                  name="seal2ID"
                  parentRef={p2idRef}
                  optDataList={propState.sealList}
                  wmItem={propState.item}
                  wmListOfTask={propState.wmWorkList[`${props.actTask}`].wmlist}
                  taskId={props.actTask}
                  lookupFieldReload={lookupFieldReload}
                  setLookupFieldReload={setLookupFieldReload}
                  disabled={!!propStateListWmItem.current.id || isButtonDisabled}
                />
              ) : (
                <Form.Control
                  disabled={!!propStateListWmItem.current.id || isButtonDisabled}
                  type="text"
                  placeholder="Biztonsági záróelem-2 száma"
                  onBlur={onInputChange}
                  defaultValue={propStateListWmItem.current.plomba2_identifier}
                  name="seal2ID"
                  ref={p2idRef}
                />
              )}
            </Col>
            <Col xs="auto">
              <Button
                disabled={!!propStateListWmItem.current.id || isButtonDisabled}
                className="px-1 mx-0 py-0 "
                variant="outline-dark"
                onClick={() => {
                  /* wmBcode.enter(); */ setBarcodeScannerOn(p2idRef);
                }}
              >
                <h5>
                  <FaQrcode />
                </h5>
              </Button>
            </Col>
          </Form.Row>
        </Form.Group>
        <Form.Group controlId="p2ok">
          <Form.Label className="my-1 mr-2">
            <small style={{ color: "indigo", textAlign: "left" }}>
              Záróelem-2 állapota:
            </small>
          </Form.Label>
          <Form.Control
            disabled={isButtonDisabled}
            onBlur={onInputChange}
            as="select"
            className="my-1 mr-sm-2"
            custom
            ref={p2okRef}
            defaultValue={propStateListWmItem.current.plomba2_ok}
          >
            <option value={null}>Hiányzik</option>
            <option value={true}>Ép</option>
            <option value={false}>Sérült</option>
          </Form.Control>{" "}
        </Form.Group>
        <Form.Group controlId="note">
          <Form.Label>
            <small style={{ color: "indigo", textAlign: "left" }}>
            Szerelő megjegyzése az ügyfél felé:
            </small>
          </Form.Label>
          <Form.Control
            disabled={isButtonDisabled}
            as="textarea" rows="3"
            placeholder="Szerelő megjegyzése az ügyfél felé"
            onBlur={onInputChange}
            defaultValue={propStateListWmItem.current.note}
            name="note"
            ref={noteRef}
          />
        </Form.Group>
      </Form>
    </>
  );
};
export default WmeterForm;
